import { Link } from '@tanstack/react-router';
import type { MockCall } from '@/data/mock';
import { STATUS_CONFIG } from '@/data/mock';

interface CallRowProps {
  call: MockCall;
}

export function CallRow({ call }: CallRowProps) {
  const { cls, label } = STATUS_CONFIG[call.status];

  return (
    <Link
      to="/klici/$id"
      params={{ id: String(call.id) }}
      className="call-row"
    >
      {/* Avatar initials */}
      <span style={{
        width: '38px',
        height: '38px',
        borderRadius: '50%',
        background: 'var(--app-raised2)',
        border: '1px solid var(--app-line2)',
        display: 'grid',
        placeItems: 'center',
        fontFamily: 'var(--font-mono)',
        fontSize: '0.72rem',
        color: 'var(--copper-300)',
        flexShrink: 0,
      }}>
        {call.init}
      </span>

      {/* Main text */}
      <div style={{ minWidth: 0 }}>
        <div style={{
          fontSize: '0.9rem',
          fontWeight: 540,
          color: 'var(--app-strong)',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}>
          {call.who}
        </div>
        <div style={{
          fontSize: '0.78rem',
          color: 'var(--app-muted)',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          marginTop: '0.15rem',
        }}>
          {call.snip}
        </div>
      </div>

      {/* Meta (right) */}
      <div style={{
        textAlign: 'right',
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: '0.35rem',
      }}>
        <span className={`pill ${cls} pill--dot`}>{label}</span>
        <span style={{
          fontFamily: 'var(--font-mono)',
          fontSize: '0.7rem',
          color: 'var(--app-subtle)',
        }}>
          {call.time} · {call.dur}
        </span>
      </div>
    </Link>
  );
}
